// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  //baseUrl: 'http://ec2-15-184-90-211.me-south-1.compute.amazonaws.com:65000/api',
 // baseUrl: 'https://server.t4travels.com/api',
 baseUrl: '',
//baseUrl: 'https://localhost:8089/api',
//backSystemBaseUrl: 'http://localhost:8087/api',
  backSystemBaseUrl: 'http://ec2-65-0-58-85.ap-south-1.compute.amazonaws.com:8065/api',
  logoPath: '',
  companyName:'',
  isPakistan: false,
  operatingCountry: '',
  androidPath: '',


};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
